import * as React from 'react';
import { makeStyles } from '@material-ui/styles';
const useDotsStyles = (props) => makeStyles({
    dot: {
        zIndex: 100,
        width: 6,
        height: 6,
        borderRadius: '50%',
        position: 'absolute',
        backgroundColor: props.color,
    },
    dotLeft: {
        left: '2.5%',
    },
    dotRight: {
        right: '2.5%',
    },
});
const Dots = (props) => {
    const classes = useDotsStyles({ color: props.color })();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `${classes.dot} ${classes.dotLeft}` }),
        React.createElement("div", { className: `${classes.dot} ${classes.dotRight}` })));
};
export default Dots;
